const ENABLE_KEY_POSE_TIMING_LOGS = import.meta.env.DEV;

type KeyPoseTimingDetails = Record<string, unknown>;

const noopKeyPoseTimingLogger = {
  mark: () => {},
  end: () => {},
};

export function createKeyPoseTimingLogger(
  scope: string,
  initialDetails?: KeyPoseTimingDetails,
) {
  if (!ENABLE_KEY_POSE_TIMING_LOGS) {
    return noopKeyPoseTimingLogger;
  }

  logKeyPoseTiming(scope, 'start', initialDetails);

  const start = getTimingNow();
  let previous = start;

  return {
    mark(label: string, details?: KeyPoseTimingDetails) {
      const now = getTimingNow();
      logKeyPoseTiming(scope, label, {
        stepMs: formatDuration(now - previous),
        totalMs: formatDuration(now - start),
        ...details,
      });
      previous = getTimingNow();
    },
    end(label = 'end', details?: KeyPoseTimingDetails) {
      const now = getTimingNow();
      logKeyPoseTiming(scope, label, {
        stepMs: formatDuration(now - previous),
        totalMs: formatDuration(now - start),
        ...details,
      });
    },
  };
}

export function logKeyPoseTiming(
  scope: string,
  label: string,
  details?: KeyPoseTimingDetails,
) {
  if (!ENABLE_KEY_POSE_TIMING_LOGS) {
    return;
  }

  const writeLog = () => {
    if (details) {
      console.log(`[keyPoseTiming:${scope}] ${label}`, details);
      return;
    }

    console.log(`[keyPoseTiming:${scope}] ${label}`);
  };

  // Keep diagnostic console overhead out of the measured synchronous work.
  queueMicrotask(writeLog);
}

export function getKeyPoseTimingNow() {
  return getTimingNow();
}

function getTimingNow() {
  return typeof performance !== 'undefined' ? performance.now() : Date.now();
}

function formatDuration(durationMs: number) {
  return Math.round(durationMs * 100) / 100;
}
